module.exports = __webpack_public_path__ + "img/jisu.26f36799.png";